<template>
	<div class="auth">
		<div class="auth-container">
			<div class="col-12 col-lg-4 col-md-4">
				<LogoContainer />
			</div>
			<div class="col-12 col-lg-4 col-md-8">
				<div class="auth-card" v-if="!confirmSignUp">
					<div class="auth-card-header">
						<p class="h2 text-center">/ BUILDlite /</p>
					</div>
					<div class="auth-card-body">
						<form>
							<p class="text-left">Sign up with a new account</p>

							<BaseInput
								label="Email"
								type="email"
								v-model="email"
								:errorMsg="validationErrors.email"
							/>
							<BaseInput
								label="name"
								v-model="name"
								:errorMsg="validationErrors.name"
							/>
							<BaseInput
								label="Contact Number"
								v-model="contactNumber"
								:errorMsg="validationErrors.contactNumber"
							/>
							<BaseInput
								label="Company Name"
								v-model="companyName"
								:errorMsg="validationErrors.companyName"
							/>
							<BaseInput
								label="Password"
								type="password"
								v-model="password"
								:errorMsg="validationErrors.password"
							/>
							<p
								v-if="!validationErrors.password"
								class="warning"
							>
								Requires numbers and character, and the minimum
								length is 8
							</p>
							<button class="btn-login" @click.prevent="signUp">
								Sign up
							</button>
							<p class="text-center mt-2">
								Already have an account?
								<a @click.prevent="toLogin">Sign in</a>
							</p>
						</form>
						<!-- Default form subscription -->
					</div>
					<!-- Card body -->
				</div>
				<!-- Card -->

				<div class="auth-card" v-else>
					<div class="auth-card-header">
						<p class="h2 text-center my-3">/ BUILDlite /</p>
					</div>
					<div class="auth-card-body">
						<form>
							<!-- <p class="h2 text-center py-4 auth-logo">Build Lite</p> -->
							<p class="text-left">
								We have sent a code by email to {{ email }}.
								Enter it below to confirm your account.
							</p>
							<BaseInput
								label="Verification Code"
								type="password"
								v-model="verificationCode"
								:errorMsg="validationErrors.verificationCode"
							/>

							<button
								class="btn-login"
								@click.prevent="confirmingUser"
							>
								Confirm Account
							</button>
							<p class="text-center mt-2">
								Didn't receive a code?
								<a @click.prevent="resendConfirmationCode"
									>Resend it</a
								>
							</p>
						</form>
						<!-- Default form subscription -->
					</div>
					<!-- Card body -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue'
import {
	CognitoUserAttribute,
	CognitoUserPool
} from 'amazon-cognito-identity-js'
import { poolData } from '@/services/CognitoService.js'
import store from '@/store/store'
import * as yup from 'yup'
import { getValidationErrors } from '@/utils/Help.js'
import NProgress from 'nprogress'
import LogoContainer from '@/components/LogoContainer.vue'

const signUpSchema = yup.object().shape({
	email: yup
		.string()
		.label('Email')
		.required("Email can't be empty."),
	name: yup
		.string()
		.label('Name')
		.required("Name can't be empty."),
	contactNumber: yup
		.string()
		.label('Contact Number')
		.required("Contact Number can't be empty."),
	companyName: yup
		.string()
		.label('Company Name')
		.required("Company Name can't be empty."),
	password: yup
		.string()
		.label('Password')
		.matches(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/, {
			message:
				'Password requires numbers and character, and the minimum length is 8',
			excludeEmptyString: true
		})
		.required("Password can't be empty.")
})

const confirmingUserSchema = yup.object().shape({
	verificationCode: yup
		.number()
		.typeError('Verification Code must be a number')
		.label('Verification Code')
		.required("Verification Code can't be empty.")
})

export default {
	name: 'SignUp',
	data() {
		return {
			confirmSignUp: false,
			contactNumber: '',
			companyName: '',
			email: '',
			username: '',
			name: '',
			password: '',
			verificationCode: '',
			cognitoUser: {},
			validationErrors: {}
		}
	},
	components: {
		BaseInput,
		LogoContainer
	},
	methods: {
		async signUp() {
			NProgress.start()
			const userInput = {
				email: this.email,
				password: this.password,
				name: this.name,
				contactNumber: this.contactNumber,
				companyName: this.companyName
			}
			try {
				await signUpSchema.validate(userInput, {
					abortEarly: false
				})
				const userPool = new CognitoUserPool(poolData)
				let attributeList = []
				this.name &&
					attributeList.push(
						new CognitoUserAttribute({
							Name: 'name',
							Value: this.name
						})
					),
					this.email &&
						attributeList.push(
							new CognitoUserAttribute({
								Name: 'email',
								Value: this.email
							})
						),
					attributeList.push(
						new CognitoUserAttribute({
							Name: 'profile',
							Value: 'Client'
						})
					),
					attributeList.push(
						new CognitoUserAttribute({
							Name: 'custom:company_name',
							Value: this.companyName
						})
					)
				attributeList.push(
					new CognitoUserAttribute({
						Name: 'custom:contact_number',
						Value: this.contactNumber.toString()
					})
				)

				const self = this

				userPool.signUp(
					this.email,
					this.password,
					attributeList,
					null,
					function(err, result) {
						if (err) {
							if (err.code === 'UsernameExistsException') {
								const notification = {
									type: 'error',
									message: err.message
								}
								store.dispatch(
									'notification/add',
									notification,
									{
										root: true
									}
								)
							} else {
								const notification = {
									type: 'error',
									message: `Oops! Something went wrong.`
								}
								store.dispatch(
									'notification/add',
									notification,
									{
										root: true
									}
								)
							}
							NProgress.done()
							return
						}
						self.confirmSignUp = true
						self.cognitoUser = result.user
						NProgress.done()
						console.log(
							'user name is ' + self.cognitoUser.getUsername()
						)
					}
				)
			} catch (err) {
				if (err.name === 'ValidationError') {
					this.validationErrors = getValidationErrors(err)
				}
				console.log(err)
				NProgress.done()
			}
		},
		async confirmingUser() {
			NProgress.start()
			const userInput = {
				verificationCode: this.verificationCode
			}
			try {
				await confirmingUserSchema.validate(userInput, {
					abortEarly: false
				})
				const self = this
				console.log(this.cognitoUser)
				this.cognitoUser.confirmRegistration(
					this.verificationCode,
					true,
					function(err, result) {
						if (err) {
							console.log(err)
							alert(err)
							NProgress.done()
							return
						}
						NProgress.done()
						const notification = {
							type: 'success',
							message:
								'Congratulations, Your account is confirmed.'
						}
						store.dispatch('notification/add', notification, {
							root: true
						})
						self.$router.push({ name: 'login' })
					}
				)
			} catch (err) {
				console.log(err)
				if (err.name === 'ValidationError') {
					this.validationErrors = getValidationErrors(err)
				}
				NProgress.done()
			}
		},
		toLogin() {
			this.$router.push({ name: 'login' })
		},
		resendConfirmationCode() {
			NProgress.start()
			this.cognitoUser.resendConfirmationCode(function(err, result) {
				if (err) {
					NProgress.done()
					alert(err)
					return
				}
				NProgress.done()
				alert(result)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/auth.scss';
</style>
